
<!--
  - Copyright (c) 2021 by Leyton Group - All Rights Reserved.
  -  This source code, and resulting software, is the confidential and proprietary information
  -  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  -  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  -  and shall use it only in accordance with the terms and conditions of any and all license
  -  agreements you have entered into with The Company.
  -->

<template>
  <div id="reglementaire">
    <reglementaire-link v-if="$route.name !== 'Article'" :id="getWork.id"></reglementaire-link>
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { reglementaireService } from "@/views/Reglementaire/services";
import ReglementaireLink from "../../components/static/reglementaire/ReglementaireLink.vue";

export default {
  name: "Reglementaire",
  components: { ReglementaireLink },
  data() {
    return {
      loadingReg: false,
      isLoadingFile: {
        loading: false,
        id: null,
      },
      news: null,
      info_fiche: null,
      models: null,
    };
  },
  mounted() {
    this.getRegkByIdAction({ id: parseInt(this.$route.params["id"], 10) });
    this.getReglementaires();
  },
  computed: {
    ...mapGetters("work", ["getWork"]),
  },
  methods: {
    ...mapActions("work", ["getRegkByIdAction"]),
    ...mapMutations({
      toggleSidebar: "leftsidebar/toggleSidebar",
      setSidebarShow: "leftsidebar/setSidebarShow",
    }),
    getReglementaires() {
      this.loadingReg = true;
      reglementaireService
        .fetchReglementaires()
        .then(
          (result) => {
            if (result && result.length > 0) {
              this.news = result.filter((val) => val.category === "NEWS");
              this.info_fiche = result.filter(
                (val) => val.category === "INFORMATION_FICHE"
              );
              this.models = result.filter((val) => val.category === "MODELS");
            }
          },
          (error) => {
            console.log(error);
          }
        )
        .finally(() => (this.loadingReg = false));
    },
    downloadOrOpenLink(element) {
      if (element.file) {
        this.isLoadingFile = { loading: true, id: element.id };
        reglementaireService
          .downloadRegFile(element.id)
          .finally(() => (this.isLoadingFile = { loading: false, id: null }));
      } else {
        window.open(element.link, "_blank");
      }
    },
  },
};
</script>

<style scoped>
</style>
